"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchMediaCampaignDto = void 0;
const cursor_pagination_1 = require("../cursor-pagination");
class SearchMediaCampaignDto extends cursor_pagination_1.CursorPaginationOptions {
    ownerId;
    notOwnerId;
    displayId;
    displayOwnerId;
    notDisplayOwnerId;
    displayProviderId;
    mediaId;
    reqId;
    playlistId;
    from;
    to;
    date;
    mediaCampaignId;
    showWithPrice;
    showAccepted;
    isExpired;
    isPaid;
    status;
    notStatus;
    flatten;
    createdAtFrom;
    createdAtTo;
    distinct;
    deliverySettlementOutcome;
}
exports.SearchMediaCampaignDto = SearchMediaCampaignDto;
